import QRCode from 'qrcode';

// Generate QR code for vehicle with simple vehicle number format
export const generateVehicleQR = async (vehicleNumber) => {
  try {
    // Simple format: just the vehicle number
    const qrData = vehicleNumber.trim().toUpperCase();
    
    // Generate QR code as data URL
    const qrCodeDataUrl = await QRCode.toDataURL(qrData, {
      width: 300,
      margin: 2,
      color: {
        dark: '#000000',
        light: '#FFFFFF'
      }
    });
    
    return {
      data: qrData,
      dataUrl: qrCodeDataUrl
    };
  } catch (error) {
    console.error('Error generating QR code:', error);
    throw error;
  }
};

// Generate QR code as SVG string
export const generateVehicleQRSVG = async (vehicleNumber) => {
  try {
    const qrData = vehicleNumber.trim().toUpperCase();
    
    const qrCodeSVG = await QRCode.toString(qrData, {
      type: 'svg',
      width: 300,
      margin: 2
    });
    
    return {
      data: qrData,
      svg: qrCodeSVG
    };
  } catch (error) {
    console.error('Error generating QR code SVG:', error);
    throw error;
  }
};

// Generate multiple QR codes for testing
export const generateTestQRCodes = async () => {
  const vehicles = [
    { number: 'AP39KU2747', flat: 'FLAT001' },
    { number: 'KA05MN1234', flat: 'FLAT002' },
    { number: 'TN09AB5678', flat: 'FLAT003' }
  ];
  
  const qrCodes = [];
  
  for (const vehicle of vehicles) {
    try {
      const qr = await generateVehicleQR(vehicle.number, vehicle.flat);
      qrCodes.push({
        vehicleNumber: vehicle.number,
        flatId: vehicle.flat,
        ...qr
      });
    } catch (error) {
      console.error(`Failed to generate QR for ${vehicle.number}:`, error);
    }
  }
  
  return qrCodes;
};